export default "__VITE_ASSET__7c9b23f6__"